import * as Sentry from "@sentry/react";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { checkStudentAPI, checkUserAPI, fetchStudentAPI } from "./studentAPI";

export const checkStudent = createAsyncThunk(
  "student/checkStudent",
  async ({ studentId, randomCode }, { rejectWithValue }) => {
    try {
      const response = await checkStudentAPI(studentId, randomCode);
      if (response.status === 200) {
        Sentry.setUser({ id: "student_" + studentId });
      }
      return response; // 200 or 401
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const checkUser = createAsyncThunk(
  "student/checkUser",
  async ({ userId, randomCode }, { rejectWithValue }) => {
    try {
      const response = await checkUserAPI(userId, randomCode);
      if (response.status === 200) {
        Sentry.setUser({ id: "user_" + userId });
      }
      return response; // 200 or 401
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchStudent = createAsyncThunk(
  "student/fetchStudent",
  async ({ studentId, randomCode }, { rejectWithValue }) => {
    try {
      const response = await fetchStudentAPI(studentId, randomCode);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const studentSlice = createSlice({
  name: "student",
  initialState: {
    isAuthenticated: false,
    student: {
      id: null,
      name: "",
      grade: 0,
    },
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkStudent.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.status === 200;
        state.error = null;
      })
      .addCase(checkStudent.rejected, (state, action) => {
        state.isAuthenticated = false;
        state.student = {
          id: null,
          name: "",
          grade: 0,
        };
        state.error = action.payload;
      })
      .addCase(checkUser.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.status === 200;
        state.error = null;
      })
      .addCase(checkUser.rejected, (state, action) => {
        state.isAuthenticated = false;
        state.error = action.payload;
      })
      .addCase(fetchStudent.fulfilled, (state, action) => {
        state.student = action.payload;
        state.error = null;
      })
      .addCase(fetchStudent.rejected, (state, action) => {
        state.student = {
          id: null,
          name: "",
          grade: 0,
        };
        state.error = action.payload;
      });
  },
});

export default studentSlice.reducer;
